import { init } from '@amplitude/analytics-browser';

export default class AmplitudeManager {
  static init ({ amplitudeApiKey, appVersion }) {
    const DEFAULT_API_KEY = 'f63d74089ecefef085a8b95e757e695e'
    init(amplitudeApiKey || DEFAULT_API_KEY, '', { appVersion });
  }
}